export default {"src":"/_next/static/media/star_x2.0bc96482.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};